import Cart_1 from './Cart_1';
import Cart_2 from './Cart_2';
import Cart_3 from './Cart_3';
import Cart_4 from './Cart_4';
import Cart_6 from './Cart_6';
import Cart_ProteinOcean from './Cart_ProteinOcean';
import Cart_Yenir from './Cart_Yenir';

export const Cart = {
  Cart_1: Cart_1,
  Cart_2: Cart_2,
  Cart_3: Cart_3,
  Cart_4: Cart_4,
  Cart_6: Cart_6,
  Cart_ProteinOcean: Cart_ProteinOcean,
  Cart_Yenir: Cart_Yenir,
};
